const getValidationLabel = (label: string): string => label.replace('*', '');

export const validationMessages = {
  required: (label: string): string => `${getValidationLabel(label)} is required.`,
  invalid: (label: string): string => `${getValidationLabel(label)} is not valid.`,
  invalidFileType: (allowedTypes: string): string => `Please provide ${allowedTypes} file type.`,
  invalidFileSize: (maxSizeMB: number): string => `File too large, cannot exceed, ${maxSizeMB}MB.`,
  maxLength: (label: string, maxLength: number): string =>
    `${getValidationLabel(label)} must be ${maxLength} characters or less.`
};
